export default "__VITE_PUBLIC_ASSET__c9103796__"